// Generated by CoffeeScript 2.7.0
var Detail;

import Base from './base.js';

export default Detail = (function() {
  class Detail extends Base {
    static resolveTypedAttributes(attributes, _specified_attributes, _from_field_type) {
      attributes.settings.button_name = '明细';
      return attributes;
    }

    constructor(attrs = {}, logic_settings = {}, fieldable) {
      super(attrs, logic_settings, fieldable);
      this.children = _.chain(attrs.children).map((field) => {
        var _field;
        _field = Base.new(field, logic_settings, fieldable);
        _field.detail = this;
        return _field;
      }).sortBy('position').compact().value();
    }

    getDisappearedFieldIdsOnInit() {
      return _.chain(this.children).map(function(child) {
        return typeof child.getDisappearedFieldIdsOnInit === "function" ? child.getDisappearedFieldIdsOnInit() : void 0;
      }).flatten().uniq().compact().value();
    }

    toJSON() {
      var field;
      field = super.toJSON();
      field.children_attributes = _.map(this.children, function(child, index) {
        child.position = index;
        return child.toJSON();
      });
      return field;
    }

  };

  Detail.prototype.availableLayouts = ['block'];

  return Detail;

}).call(this);
